import React, { Component } from 'react';


import './index.css'
import { BsyUtils } from '../../../utils/Utils';
import { BsyDashUtils } from '../../../utils/DashUtils';
import { BsyConfig } from '../../../global/BsyConfig'
import BsySLoading from '../../BsySLoading';
import BsyAlertMenu from '../../BsyAlertMenu';
import { getAfterSuffix } from '../../../utils/getAfterSuffix';


export default class BsyMetricTable extends Component {

  static defaultProps = {
    url: '/data/report_combined_group',
    widgetId: "",
    form: null,
    xFields: [],
    valueFields: [],
    filter: {},
    thresholds: [],
    componentAttr: null,
    top: {},
    mode: "edit",
    title: '',
    valueMinSize: 25,
    sort: [],
    onDataFilter: null,
    onLoadFail: null,
    data: {},
    styles: {},
    autoLoad: true,
    onItemClick: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      url: props.url,
      appId: props.appId,
      entryId: props.entryId,
      widgetId: props.widgetId,
      form: props.form,
      xFields: props.xFields,
      valueFields: props.metrics,
      filter: props.filter,
      thresholds: props.thresholds,
      componentAttr: props.componentAttr,
      top: props.top,
      mode: props.mode,
      contentHeight: 57,
      contentWidth: 114,
      styles: { ...props.styles },
      title: props.title ? props : React.language("dash.chart.unnamed"),
      valueMinSize: props.valueMinSize,
      sort: props.defaultSort,
      onDataFilter: props.onDataFilter,
      onLoadFail: props.onLoadFail,
      data: props.data,
      isLoading: true,
      autoLoad: props.autoLoad,
      dataEmpty: false,
      chartType: 'metric_table'
    };
    this.isDashFull = props.isDashFull;
    this.contentRef = React.createRef();
    this.refLoadNum = React.createRef();
    this.filterParam = null;
  }

  _getStyles = () => {
    const { widgetId } = this.state;

    if (!this._hasDimension()) {
      this.styles = BsyUtils.applyFunc(this, this.props.onGetStyles, [widgetId], !1)
      if (this.styles) {
        this.preset = BsyDashUtils().getDashStylesCardName(this.styles);
      } else {
        this.preset = this.props.styles && this.props.styles.theme && this.props.styles.theme.cardName
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

    if (nextProps.isDashFull !== this.isDashFull) {
      this.isDashFull = nextProps.isDashFull;
      this.setState({})
    }
  }

  componentDidMount() {

    if (this.props.getContext) {
      this.props.getContext(this);
    }

    // console.log('componentDidMount', this.contentRef)
    this.contentHeight = this.contentRef.current.offsetHeight;
    this.contentWidth = this.contentRef.current.offsetWidth;
    this.setState({
      contentHeight: this.contentHeight,
      contentWidth: this.contentWidth,
    })
    if (!this.props.mountAutoLoad) {

      return
    }
    this.loadWidget()
  }

  loadWidget = (n, d) => {

    this.loadData(n, d);
  }

  reload = (options) => {
    this.setState({
      ...this.state,
      ...options
    }, () => {
      this.loadData()
    })
  }

  loadData = (n, d) => {
    const { url, sort, valueFields } = this.state;
    const { widgetId, appId, entryId } = this.props;

    let autoload = this.props.autoLoad;
    if (this.props.onIsAutoLoad)
      autoload = this.props.onIsAutoLoad()

    if (!autoload) {
      this.setState({
        dataEmpty: true,
        isLoading: false,
      })
      return
    }
    this.isDashFull = n;
    this.setState({
      isLoading: true,
    })
    React.axios(url, {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
      sort: sort,
      filter: this.getFilterData(this.filterParam),
      env: this.props.env || undefined,
    }, { dashMode: n, autoShowMsg: this.props.env === "dashboard" }).then(res => {

      if (res.data.hasOwnProperty('code') && res.data.code === 3000) {
        //onConfigError
        if (this.props.onConfigError) {
          this.props.onConfigError(res.data)
        }
        if (this.props.onLoadFail) {
          this.props.onLoadFail(n, d)
        }
        return;
      }

      BsyUtils.showAjaxTip(res.data, () => {
        this._getStyles();

        this.nameMap = res.data.user;

        if (this._hasDimension()) {
          this.setState({
            data: { ...res.data },
            isLoading: false,
            dataEmpty: false
          }, () => {
            BsyUtils.applyFunc(this, this.props.onLoadSuccess, [res.data, n, d], !1)
          })
        } else {

          this.setState({
            data: { ...res.data },
            isLoading: false,
            dataEmpty: false
          }, () => {
            if (this.contentRef.current) {
              this.presetNoDimension(res.data)
              BsyUtils.applyFunc(this, this.props.onLoadSuccess, [res.data, n, d], !1)
            } else {
              setTimeout(() => {
                this.presetNoDimension(res.data)
                BsyUtils.applyFunc(this, this.props.onLoadSuccess, [res.data, n, d], !1)
              }, 100)
            }
          })
        }

      }, () => {
        if (this.props.onLoadFail) {
          this.props.onLoadFail(n, d)
        }
      })

    }).catch(res => {
      if (this.props.onConfigError) {
        if (res.status) {
          this.props.onConfigError(res.data);
        }
      }
      if (this.props.onLoadFail) {
        this.props.onLoadFail(n, d)
      }
      console.error(res);
      this.setState({
        isLoading: false,
      })
    })
  }

  presetNoDimension = (res) => {
    const { valueFields } = this.state;
    let e = res.data.val;
    this.oriSum = !BsyUtils.isObjectEmpty(e) && e[0].sum || 0
    this.sum = this._formatData(this.oriSum)
    this.unit = valueFields[0].unit || ""
    this.valFontCount = this.sum.toString().length;
    this.contentHeight = this.contentRef.current.offsetHeight;
    this.contentWidth = this.contentRef.current.offsetWidth;
    let contentHeight = this.contentHeight;
    let contentWidth = this.contentWidth;
    switch (this.preset) {

      case "preset_metric_2": {
        let dd = this._computeContentWrapperSize(27, 9, 38, 17)
        contentHeight = dd.height;
        contentWidth = dd.width;
        break;
      }
      case "preset_metric_3": {
        let dd = this._computeContentWrapperSize(29, 13, 38, 17)
        contentHeight = dd.height;
        contentWidth = dd.width;
        break;
      }
      case "preset_metric_4": {
        let i = Math.min(contentHeight, contentWidth) - 10;
        contentHeight = .5 * i;
        contentWidth = .35 * i;
        break;
      }
      case "preset_metric_8":
      case "preset_metric_9":
      case "preset_metric_10":
        let i = Math.min(contentHeight, contentWidth) - 10;
        contentHeight = i;
        contentWidth = i;
        break;
      case "preset_metric_6":
      case "preset_metric_7":
      case "preset_metric_5": {
        let dd = this._computeContentWrapperSize(38, 13, 38, 17)
        contentHeight = dd.height;
        contentWidth = dd.width;
        break;
      }
      default: {
        contentHeight = this._resizePreset1()
        break;
      }
    }
    this._initFontSize(contentHeight);
    this.setState({
      color: this.styles && this.styles.fontSetting && this.styles.fontSetting.valueColor,
      contentHeight: contentHeight,
      contentWidth: contentWidth,
      valueMinSize: this.valueminSize,
      sum: BsyUtils.isObjectEmpty(this.sum) ? "" : this.sum,
      unit: BsyUtils.isObjectEmpty(this.unit) ? "" : this.unit,
      data: res
    })
  }

  _computeContentWrapperSize = (t, e, i, a) => {
    function n() {
      r = (o = l / a * e) / e * t
    }
    function s() {
      o = (r = c / i * t) / t * e
    }
    let o, r, l = this.contentHeight, c = this.contentWidth;
    if (l < c) {
      n()
      c <= r && s()
    } else {
      s()
      l <= o && n()
    }
    return {
      width: r,
      height: o
    }
  }

  getFilterData = (t) => {
    let e = this.props
      , i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1)
      , a = [];
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    i && (a = a.concat(i))
    BsyUtils.isObjectEmpty(t) || (a = a.concat(t))
    e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond))
    return BsyUtils.isObjectEmpty(a) ? {} : {
      cond: a,
      rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND
    }
  }

  _setFilterParam = (t) => {
    BsyUtils.isNull(t) || (this.filterParam = t)
  }

  _hasDimension = () => {
    const { xFields } = this.state;
    return 0 < xFields.length
  }

  _shouldShowSummaryRow = () => {
    const { top } = this.state;
    return !(top && top.enable && top.limit)
  }

  _formatLabel = (i, t) => {
    const { data } = this.state;
    let a = '';
    let e = data;
    let s = '';
    let _this = this;
    let n = null;
    switch (t.type) {
      case "user":
      case "usergroup":
        n = e.user[i];
        a = BsyUtils._toDeptUser(n, 'user');
        break;
      case "dept":
      case "deptgroup":
        n = e.department[i];
        a = BsyUtils._toDeptUser(n);
        break;
      case "datetime":
        s = t.groupRule || "year";
        a = BsyUtils.date2GroupStr(i, s);
        break;
      case "flowid":
        a = e.flowNameMap[i];
        break;
      case "location":
      case "address":
        a = "";
        s = t.groupRule && t.groupRule.split("_");
        BsyUtils.forEach(s, function (t, e) {
          BsyUtils.isEmpty(i[e]) || (a += i[e])
        });
        break;
      case "flowState":
        a = BsyUtils.getFlowStateText(i);
        break;
      case "flowdecision":
        a = BsyUtils.getFlowDecisionText(i);
        break;
      case "assist_flowid":
        if (!this.flowIdMap) {
          this.flowIdMap = {};

          BsyUtils.forEach(e.flowIdName, function (a1, a2) {
            _this.flowIdMap[a2.value] = a2.text;
          })
        }
        a = this.flowIdMap[i] || "";
        break;
      case "assist_prostatus":
        let l1 = {};
        l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS] = React.language("mobile.flow.node.doing");
        l1[BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE] = React.language("processed");
        a = l1[i] || "";
        break;
      default: {
        break;
      }
    }
    return a || i;
  }

  _createRowNumber = (title, num, isSum, cb) => {
    return <div key={title} className={"line " + (isSum ? 'sum' : 'number')} ><div className="left">{title}</div><div className="right"
      onClick={e => {
        if (!isSum) {
          cb && cb();
        }
      }}
    >{num}</div></div>
  }
  _createOneDimensionTable = () => {
    // console.log("多指标")
    const { data } = this.state;
    let n = data && data.data && data.data.val ? data.data.val : []
    let t = data && data.data && data.data.x ? data.data.x : []
    let r = null;
    if (n.length > 0) {
      t = t[0].data;
      n = n[0].data;
      r = data.xFields[0];
    }

    let sum = n.length === 0 ? 0 : data.data.val[0].sum;
    if (n.length > 0 && data.metrics[0]) {

      let res = {
        value: '',
        text: '',
      }
      if (['flow_assist.assist_protime', 'flow_assist.assist_outtime'].includes(data.metrics[0].name)) {
        res = BsyUtils.numberFormatTime(BsyUtils.fixDecimalPrecision(sum), data.metrics[0])
      } else {
        res = BsyUtils.numberFormatValue(BsyUtils.fixDecimalPrecision(sum), data.metrics[0])
        const afterSuffixVal = getAfterSuffix(data.metrics[0].afterSuffix)
        if (afterSuffixVal && res.text && !res.text.includes("%")) {
          res.text = res.text + " " +afterSuffixVal;
        }
      }

      sum = res.text;

      // sum = BsyUtils.num2Str(BsyUtils.fixDecimalPrecision(sum), data.metrics[0].format)
    }

    return <div className="content-wrapper one-dimension">
      <div className="number-lines">
        {
          this._shouldShowSummaryRow() ? this._createRowNumber(React.language("total"), n.length === 0 ? 0 : sum, true) : ''
        }
        {
          t.map((dd, index) => {
            return this._createRowNumber(this._formatLabel(dd, r), this._formatData(n[index]), false, () => {
              if (this.props.rawdata) {
                let i = [];
                let r1 = this._dealLinkData(r, dd);
                i.push(r1);
                // console.log(dd, r)
                this.linkParam = this._getLinkFilterParams(i)
                this.linkParam = this.linkParam.concat(this.getFilterData().cond);
                BsyUtils.applyFunc(this, this.props.onItemClick, [this.linkParam], !1)
              }
            });
          })
        }
      </div>
    </div>
  }

  _getLinkFilterParams = (e) => {
    let i = this.props
      , a = [];
    BsyUtils.forEach(e, function (e, n) {

      // t.extend(BsyUtils.pick(n, ["method", "type", "value", "keyType"]), FX.Utils.dealFilterInfoByField({
      //   id: i.forms[0],
      //   name: n.field
      // })
      a.push({
        ...BsyUtils.pick(n, ["method", "type", "value", "keyType"]),
        ...BsyUtils.dealFilterInfoByField({
          id: i.forms[0],
          name: n.field
        })
      })
    })
    return a
  }

  _dealLinkData = (t, e) => {

    let i = e;
    switch (t.type) {
      case "datetime":
        i = BsyUtils.getDateRange(e);
        break;
      case "address":
      case "location":
        i = BsyUtils.getArrayFromRange(i, "address");
        break;
      case "flowState":
      case "flowstate":
        let n = BsyConfig().CONST.WORKFLOW.FLOWSTATE
          , r = {};
        r[React.language("flow.state.inProcess")] = n.INPROCESS
        r[React.language("flow.state.complete")] = n.COMPLETE
        r[React.language("flow.state.closed")] = n.CLOSE
        i = r[i]
        break;
      case "flowdecision":
      case "flowDecision":
        i = this.flowDecisionMap[i]
        break;
      case 'user':
      case 'dept': {
        i = this.nameMap[i] && (this.nameMap[i]._id || this.nameMap[i].id) || i;
        break;
      }
      default: {
        break
      }
    }
    return BsyUtils.getLinkFilter(t, i)
  }

  _getLinkFilterParams = (e) => {
    let i = this.props
      , n = [];
    BsyUtils.forEach(e, function (e, r) {
      n.push({
        ...BsyUtils.pick(r, ["method", "type", "value", "keyType", 'subField', 'subform', 'field', 'subform']), ...BsyUtils.dealFilterInfoByField({
          id: i.forms[0],
          name: r.field
        })
      })
    })
    return n
  }

  _formatData = (t) => {
    const { valueFields } = this.state;
    let e = valueFields[0];

    let res = {
      value: '',
      text: '',
    }
    if (['flow_assist.assist_protime', 'flow_assist.assist_outtime'].includes(e.name)) {
      res = BsyUtils.numberFormatTime(t, e)
    } else {
      res = BsyUtils.numberFormatValue(t, e);
      const afterSuffixVal = getAfterSuffix(e.afterSuffix)
      if (afterSuffixVal && res.text && !res.text.includes("%")) {
        res.text = res.text + " " +afterSuffixVal;
      }
    }
    // let res = BsyUtils.numberFormatValue( t, e);
    return res.text;
  }

  _createNoDimensionTable = () => {
    return this._createPreset()
  }

  _isThresholdsAlert = () => {
    const { valueFields } = this.state;
    return BsyDashUtils().checkThresholdAlert(this.oriSum, {
      tag: valueFields[0] && valueFields[0].tag
    }, this.props.thresholds)
  }

  oldNum = {
    num: ""
  }

  _createPreset = (t) => {
    const { valueMinSize, color, sum, unit, contentHeight, contentWidth, isLoading } = this.state;
    const { isDashFull } = this.props
    let vt = contentHeight;
    vt = contentHeight - (contentHeight / 130 * 32 + 5);
    let tf3 = vt / 154 * 65 / 1.4;
    let changeNum = false;
    let oldNum = JSON.parse(JSON.stringify(this.oldNum));
    if (sum && !isLoading) {
      if (this.oldNum.num !== sum) {
        changeNum = true;
        this.oldNum.num = sum;
      }
    } else {
      changeNum = false;
      this.oldNum.num = sum;
    }

    let tf2 = .46 * contentHeight / 1.4
    if (tf2 > contentWidth / 2) {
      tf2 = contentWidth / 2;
    }

    let cLH = contentHeight - (vt / 94 * 18) - (contentHeight / 130 * 32 + 5) - ((contentHeight - (contentHeight / 130 * 32 + 5)) * .09);
    if (tf3 > cLH) {
      tf3 = cLH;
    }

    let tf4 = .36 * contentWidth
    if (tf4 > contentWidth / 2) {
      tf4 = contentWidth / 2;
    }

    let tf5 = contentHeight * .3
    // if (tf5 > contentHeight / 2) {
    //   tf5 = contentHeight / 2;
    // }

    switch (this.preset) {
      case "preset_metric_2": {
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight + 'px', width: contentWidth + 'px' }}>
          <div className="wrapper-icon">
            <i className={"icon-cover-" + ((this.styles && this.styles.theme && this.styles.theme.icon) ? this.styles.theme.icon : "1")} style={{ height: contentHeight + 'px', width: contentHeight + 'px', }}></i>
          </div>
          <div className="wrapper-info" style={{
            color: BsyDashUtils().getDashStylesTitleColor(this.styles),
            right: (contentHeight + 10) + 'px',
            "fontSize": .33 * contentHeight / 1.4,
            "letterSpacing": .33 * contentHeight / 1.4 * .0464285714285714 + 'px',
            "lineHeight": contentHeight / 2 + 'px'
          }} >{this.props.title}</div>
          <div className="wrapper-text" title={sum + unit} style={{ color: color, right: (contentHeight + 10) + 'px' }}  >
            <div className="wrapper-group" style={{
              "height": contentHeight / 2 + 'px'
            }}>
              {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                "fontSize": tf2,
                "height": contentHeight / 2 + 'px',
                "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${contentHeight / 2}px)` : ''),
                "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                "lineHeight": contentHeight / 2 + 'px'
              }} >{oldNum.num}</span>}
              <span className="text-val" style={{
                "fontSize": tf2,
                "height": contentHeight / 2 + 'px',
                "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${contentHeight / 2}px)` : ''),
                "lineHeight": contentHeight / 2 + 'px'
              }} >{sum}</span>
            </div>
            {
              !BsyUtils.isEmpty(this.unit) ? <span className={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                "fontSize": .66 * contentHeight * .65 / 1.4,
                "lineHeight": 1.4
              }}>{this.unit}</span> : ''
            }
          </div>
        </div>
      }
      case "preset_metric_3": {
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight + 'px', width: contentWidth + 'px' }}>
          <div className="wrapper-main" style={{ top: contentHeight / 130 * 32 + 5 }}>
            <div className="wrapper-text" title={sum + unit} style={{ color: color, top: vt / 94 * 18 }}  >
              <div className="wrapper-group" style={{
                "height": cLH + 'px'
              }}>
                {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                  "fontSize": tf3,
                  "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${cLH}px)` : ''),
                  "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                  "height": cLH + 'px',
                  "lineHeight": cLH + 'px'
                }} >{oldNum.num}</span>}
                <span className="text-val" style={{
                  "fontSize": tf3,
                  "height": cLH + 'px',
                  "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                  "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${cLH}px)` : ''),
                  "lineHeight": cLH + 'px'
                }} >{sum}</span>
              </div>
              {
                !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                  "fontSize": vt / 94 * 65 * .65 / 1.4,
                  "lineHeight": 1.4
                }}>{this.unit}</span> : ''
              }
            </div>
          </div>
          <div className="wrapper-info" style={{
            color: BsyDashUtils().getDashStylesTitleColor(this.styles),
            "fontSize": contentHeight / 130 * 32 / 1.4,
            "letterSpacing": contentHeight / 130 * 32 / 1.4 * .0464285714285714 + 'px',
            "lineHeight": 1.4
          }} >{this.props.title}</div>
        </div>
      }
      case "preset_metric_4": {
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: (contentHeight * 2) + 'px', width: (contentHeight * 2) + 'px' }}>
          <div className="wrapper-main" style={{ height: contentWidth + 'px', width: contentHeight + 'px' }} >
            <div className="wrapper-cont">
              <div className="wrapper-info" style={{
                color: BsyDashUtils().getDashStylesTitleColor(this.styles),
                "fontSize": .23 * contentWidth / 1.4,
                "letterSpacing": .23 * contentHeight / 1.4 * .0464285714285714 + 'px',
                "lineHeight": 1.4
              }} >{this.props.title}</div>
              <div className="wrapper-text" title={sum + unit} style={{ color: color }}>
                <div className="wrapper-group" style={{
                  "height": tf4 + 'px'
                }}>
                  {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                    "fontSize": tf4,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${tf4}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": tf4 + 'px',
                    "lineHeight": tf4 + 'px'
                  }}>{oldNum.num}</span>}
                  <span className="text-val" style={{
                    "fontSize": tf4,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${tf4}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": tf4 + 'px',
                    "lineHeight": tf4 + 'px'
                  }}>{sum}</span>
                </div>
                {
                  !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                    "fontSize": .66 * contentWidth * .65,
                    "lineHeight": contentWidth / 2 + "px"
                  }}>{this.unit}</span> : ''
                }
              </div>
            </div>
          </div>
        </div>
      }
      case "preset_metric_5":
      case "preset_metric_6":
      case "preset_metric_7": {
        let t = contentHeight * .122;
        let lh5 = tf5 * 1.4;
        let ilh5 = t * 1.4;
        if (lh5 < 12) {
          lh5 = 12;
        }
        if (ilh5 < 12) {
          ilh5 = 12;
        }
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight * 0.8 + 'px', width: contentWidth + 'px' }}>
          <div className="wrapper-icon" style={{ height: contentHeight * 0.8 + 'px', width: contentHeight * 0.8 + 'px' }}>

          </div>
          <div className="wrapper-cont">
            <div className="wrapper-center">
              <div className="wrapper-info" style={{
                color: BsyDashUtils().getDashStylesTitleColor(this.styles),
                "fontSize": t,
                "letterSpacing": t * .0464285714285714 + 'px',
                "lineHeight": ilh5 + 'px'
              }} >{this.props.title}</div>

              <div className="wrapper-text" title={sum + unit} style={{ color: color }}>
                <div className="wrapper-group" style={{
                  "height": lh5 + 'px'
                }}>
                  {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                    "fontSize": tf5,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${lh5}px)` : ''),
                    "lineHeight": lh5 + 'px',
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": lh5 + 'px'
                  }}>{oldNum.num}</span>}
                  <span className="text-val" style={{
                    "fontSize": tf5,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${lh5}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "lineHeight": lh5 + 'px',
                    "height": lh5 + 'px'
                  }}>{sum}</span>
                </div>
                {
                  !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                    "fontSize": contentHeight / 100 * 56 * .65,
                    "lineHeight": 1
                  }}>{this.unit}</span> : ''
                }
              </div>
            </div>
          </div>
        </div>
      }
      case "preset_metric_8": {
        let vf8 = contentHeight * .955 * .139;
        let tf8 = contentHeight * .955 * .116;
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight + 'px', width: contentHeight + 'px' }}>
          <div className="wrapper-main" style={{ height: contentHeight * .955 + 'px', width: contentHeight * .7 + 'px' }} >
            <div className="wrapper-cont">
              <div className="wrapper-text" title={sum + unit} style={{ color: color, top: 0 }}>
                <div className="wrapper-group" style={{
                  "height": vf8 + 'px'
                }}>
                  {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                    "fontSize": vf8,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf8}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf8 + 'px',
                    "lineHeight": vf8 + 'px'
                  }}>{oldNum.num}</span>}
                  <span className="text-val" style={{
                    "fontSize": vf8,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf8}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf8 + 'px',
                    "lineHeight": vf8 + 'px'
                  }}>{sum}</span>
                </div>
                {
                  !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                    "fontSize": .66 * contentWidth * .65,
                    "lineHeight": contentWidth / 2 + "px"
                  }}>{this.unit}</span> : ''
                }
              </div>
              <div className="wrapper-info" style={{
                color: BsyDashUtils().getDashStylesTitleColor(this.styles),
                "fontSize": tf8 / 1.4,
                "letterSpacing": tf8 / 1.4 * .0464285714285714 + 'px',
                "lineHeight": 1.4,
                bottom: 0
              }} >{this.props.title}</div>
            </div>
          </div>
        </div>
      }
      case "preset_metric_9": {
        let vf9 = contentHeight * .655 * .203;
        let tf9 = contentHeight * .655 * .169;
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight + 'px', width: contentWidth + 'px' }}>
          <div className="wrapper-main" style={{ height: contentHeight * .655 + 'px', width: contentWidth * .555 + 'px', top: "10%" }} >
            <div className="wrapper-cont">
              <div className="wrapper-text" title={sum + unit} style={{ color: color, "bottom": "auto", "top": "26.2711%" }}>
                <div className="wrapper-group" style={{
                  "height": vf9 + 'px'
                }}>
                  {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                    "fontSize": vf9,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf9}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf9 + 'px',
                    "lineHeight": vf9 + 'px'
                  }}>{oldNum.num}</span>}
                  <span className="text-val" style={{
                    "fontSize": vf9,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf9}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf9 + 'px',
                    "lineHeight": vf9 + 'px'
                  }}>{sum}</span>
                </div>
                {
                  !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                    "fontSize": .66 * contentWidth * .65,
                    "lineHeight": contentWidth / 2 + "px"
                  }}>{this.unit}</span> : ''
                }
              </div>
              <div className="wrapper-info" style={{
                color: BsyDashUtils().getDashStylesTitleColor(this.styles),
                "fontSize": tf9 / 1.4,
                "letterSpacing": vf9 / 1.4 * .0464285714285714 + 'px',
                "lineHeight": 1.4,
                "bottom": "27.1186%",
                "top": "auto"
              }} >{this.props.title}</div>
            </div>
          </div>
        </div>
      }
      case "preset_metric_10": {
        let vf10 = contentHeight * .311 * .44;
        let tf10 = contentHeight * .311 * .37;
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {
          this.popMenu();
        }} style={{ height: contentHeight + 'px', width: contentWidth + 'px' }}>
          <div className="wrapper-main" style={{ height: contentHeight * .311 + 'px', width: contentWidth * .522 + 'px' }} >
            <div className="wrapper-cont">
              <div className="wrapper-text" title={sum + unit} style={{ color: color }}>
                <div className="wrapper-group" style={{
                  "height": vf10 + 'px'
                }}>
                  {isDashFull && <span ref={this.refLoadNum} className="text-val" style={{
                    "fontSize": vf10,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf10}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf10 + 'px',
                    "lineHeight": vf10 + 'px'
                  }}>{oldNum.num}</span>}
                  <span className="text-val" style={{
                    "fontSize": vf10,
                    "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${vf10}px)` : ''),
                    "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                    "height": vf10 + 'px',
                    "lineHeight": vf10 + 'px'
                  }}>{sum}</span>
                </div>
                {
                  !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')} style={{
                    "fontSize": .66 * contentWidth * .65,
                    "lineHeight": contentWidth / 2 + "px"
                  }}>{this.unit}</span> : ''
                }
              </div>
              <div className="wrapper-info" style={{
                color: BsyDashUtils().getDashStylesTitleColor(this.styles),
                "fontSize": tf10 / 1.4,
                "letterSpacing": vf10 / 1.4 * .0464285714285714 + 'px',
                "lineHeight": 1.4
              }} >{this.props.title}</div>
            </div>
          </div>
        </div>
      }
      default:
        return <div className={"content-wrapper " + (this.props.rawdata || (this.props.metricmenuSwitch && this.props.metricmenu) ? "pop" : "")} onClick={() => {

          this.popMenu();

        }} style={{ height: contentHeight + 'px' }}>
          <div className="inner-content">
            <div className="sum" title={sum + unit} style={{ color: color }}>
              <div className="wrapper-group" style={{
                "height": contentHeight + 'px'
              }}>
                {isDashFull && <span ref={this.refLoadNum} className="sum-val" style={{
                  "fontSize": valueMinSize * 0.9 + 'px',
                  "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${contentHeight}px)` : ''),
                  "height": contentHeight + 'px',
                  "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                  "lineHeight": contentHeight + 'px'
                }} >{oldNum.num}</span>}
                <span className="sum-val" style={{
                  "fontSize": valueMinSize * 0.9 + 'px',
                  "height": contentHeight + 'px',
                  "transform": ((!isLoading && changeNum && isDashFull) ? `translateY(-${contentHeight}px)` : ''),
                  "transition": ((!isLoading && changeNum && isDashFull) ? "" : "none"),
                  "lineHeight": contentHeight + 'px'
                }} >{sum}</span>
              </div>
              {
                !BsyUtils.isEmpty(this.unit) ? <span ame={"text-unit" + (this._isThresholdsAlert() ? ' show-alert ' : '')}>{this.unit}</span> : ''
              }
            </div>
          </div>
        </div>
    }

  }

  popMenu = () => {
    if (this.props.rawdata && (this.props.metricmenuSwitch && this.props.metricmenu && this.props._menuBatchEvnet)) {
      console.log(window.GlobalMouse)
      let menu = [];
      menu.push({
        text: this.props.metricmenu.type === "popupreport" ? "弹出报表" : '弹出表单',
        click: () => {
          this.props._menuBatchEvnet("", 0, [], [], [], this.props.metricmenuSwitch, this.props.metricmenu)
        }
      })
      menu.push({
        text: React.language('view.raw.data'),
        click: () => {
          BsyUtils.applyFunc(this, this.props.onItemClick, [null], !1)
        }
      })

      BsyAlertMenu({
        item: menu,
        width: 220,
        target: null,
        position: {
          left: window.GlobalMouse.pageX,
          top: window.GlobalMouse.pageY,
        },
        theme: this.props.theme,
        onClose: () => {

        }
      })

    } else if (this.props.rawdata) {
      BsyUtils.applyFunc(this, this.props.onItemClick, [null], !1)
    } else if ((this.props.metricmenuSwitch && this.props.metricmenu && this.props._menuBatchEvnet)) {
      this.props._menuBatchEvnet("", 0, [], [], [], this.props.metricmenuSwitch, this.props.metricmenu)
    }

  }

  _initFontSize = (contentHeight) => {
    this.valueminSize = Math.max(this.props.valueMinSize, Math.min(this.contentWidth / this.valFontCount / .7, contentHeight / 1.3));
    // console.log(this.valueminSize)
  }

  _resizePreset1 = (t) => {
    let e, i = this.props.value_size;
    let a = this.contentHeight;
    if (this.isFullScreen)
      e = a / 3;
    else
      switch (i) {
        case "S":
          e = a / 4;
          break;
        case "M":
          e = a / 3;
          break;
        case "L":
          e = a - 40;
          break;
        default:
          e = a / 4
      }
    return e;
  }

  doResize = () => {
    const { data } = this.state;
    if (!this._hasDimension()) {
      this.presetNoDimension(data)
    }
  }

  showLoading = () => {
    const { isLoading } = this.state;
    if (!this.isDashFull) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
    }
    if (!(this.props.autoRefresh && (this.props.autoRefresh && this.props.autoRefresh.enabled))) {
      //非自动刷新模式下
      return isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
    }
    return '';
  }

  render() {
    const { widgetId, dataEmpty } = this.state;


    return (
      <>
        <div className={'bsy-dash-metric-table ' + (this._hasDimension() ? 'one-dimension' : 'no-dimension') + ' ' + (this.preset ? this.preset : '')}
          id={widgetId}
          ref={this.contentRef}
        >
          {
            dataEmpty ? <div className={'chart-data-empty'}><div><i className={BsyUtils._getWidgetTypeIcon(this.state.chartType)}></i><span>{React.language('widget.linkdata.empty')}</span></div></div> :
              this._hasDimension() ? this._createOneDimensionTable() : this._createNoDimensionTable()
          }
          {
            this.showLoading()
          }
        </div>

      </>

    )


  }

  BBY_doSort = () => {
    let t = this.state
      , e = this
      , i = BsyUtils.getDashSortFields(t.yFields)
        .concat(BsyUtils.getDashSortFields(t.xFields))
        .concat(BsyUtils.getDashQuotaSortFields(t.valueFields))
      , a = [];
    BsyUtils.forEach(t.xFields.slice(-1).concat(t.valueFields), function (t, e) {
      a.push(e.tag)
    });
    let n = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        e.dashChartSort = new window.FX.DashChartSortPane({
          renderEl: t,
          sorts: e.state.sort,
          fields: i,
          incompatibleTags: a,
          maxCount: -1,
          hideCustomSort: !0
        })
      },
      onOk: function () {
        let t = e.dashChartSort.getSorts();
        e.hasSort = !0
        e.setState({
          sort: t,
        }, () => {
          e.loadData();
        })
        //e.dashSort.reset(t);
        n.close()
      }
    });
    n.show()
  }

}